import * as models from '@app/models';
import { InjectedIntl } from 'react-intl';
import * as Yup from 'yup';
import { IAxiosCancellation, ILocationProps } from './core.models';

export interface ICustomerProps {
	intl: InjectedIntl;
	location: ILocationProps;
}
export interface ICustomerState {
	normalSignUpUrl: string;
	quickSignUpUrl: string;
	emailChips: string[];
	addCustomerSchema: Yup.ObjectSchema<Yup.Shape<object, models.IAddCustomer>>;
	sendingEmail: boolean;
	selectedAppToShare: models.IAccountAppResponseVM;
	normalSignUpTabPanel: number;
	quickSignUpTabPanel: number;
}

export const initialCustomerState = (
	normalSignUpUrl: string,
	quickSignUpUrl: string,
	addCustomerSchema: Yup.ObjectSchema<Yup.Shape<object, models.IAddCustomer>>
): ICustomerState => ({
	normalSignUpUrl,
	quickSignUpUrl,
	emailChips: [],
	addCustomerSchema,
	sendingEmail: false,
	selectedAppToShare: null,
	normalSignUpTabPanel: 0,
	quickSignUpTabPanel: 0,
});

export interface ICustomerProps extends IAxiosCancellation, models.ISnackBarFeature {
	intl: InjectedIntl;
}



// WEBPACK FOOTER //
// ./src/models/customer.models.ts